import { useMutation } from 'react-query';
import { toIsoDate } from '../../utils';
import { controlBackdropLoading, gateOutsService, removeCache } from '../../services';
import { ImageObjType } from '../../types';

export const useAddGateOutMutation = () => {
  return useMutation(
    (props: any = {}) => {
      const otherProps: any = {};
      if (props.releaseNumber) otherProps.releaseNumber = props.releaseNumber;
      if (props.comment) otherProps.comment = props.comment;

      props = {
        containers: props.containerNumber.map((number: any, i: any) => ({
          number,
          id: props.containerId[i],
        })),
        authorizedLicensePlateNumbers: props.licensePlateNumber,
        validFrom: toIsoDate(
          props.validFrom.set({
            hour: 1,
            minute: 0,
            second: 0,
            millisecond: 0,
          }),
        ),
        validTo: toIsoDate(
          props.validTo.set({
            hour: 23,
            minute: 0,
            second: 0,
            millisecond: 0,
          }),
        ),
        clientId: props.clientId,
        yardId: props.yardId,
        ...otherProps,
      };

      return gateOutsService.add(props).then((res) => res.data);
    },
    {
      onSuccess: () => {
        removeCache(['key']);
      },
    },
  );
};

export const useCreateGateOutsByFilterMutation = () => {
  return useMutation(
    (props: any) => {
      return gateOutsService.createByFilter(props);
    },
    {
      onSuccess: () => {
        removeCache(['container', 'gate-out', 'sale', 'key']);
      },
    },
  );
};

export const useLoadedGateOutMutation = () => {
  return useMutation(
    ({ id, props }: any) => {
      return gateOutsService.loaded({ id, props });
    },
    {
      onSuccess: () => {
        removeCache(['container', 'gate-out', 'key']);
      },
    },
  );
};

export const useCompleteGateOutMutation = () => {
  return useMutation(
    ({ ids, props }: any) => {
      return Promise.all(ids.map((id: string) => gateOutsService.complete({ id, props })));
    },
    {
      onSuccess: () => {
        removeCache(['container', 'gate-out', 'key']);
      },
    },
  );
};

export const useUpdateImagesGateOutMutation = () => {
  return useMutation(
    ({ ids, photos = [] }: { ids: string[]; photos: ImageObjType[] }) => {
      controlBackdropLoading(1);

      return Promise.all(ids.map((id: string) => gateOutsService.updateImages({ id, photos })));
    },
    {
      onSettled: () => {
        controlBackdropLoading(-1);
      },
    },
  );
};
